import React, { useEffect, useState } from "react";
import Layout from "../Component/Layout";
import { BiSearch, BiShow, BiTrash } from "react-icons/bi";
import Inputbox from "../Component/Inputbox";
import Image from "../assets/Image/blank.svg";

import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import REACT_APP_API_URL from "../utils/constant";

const Users = () => {
  const [UserLists, setUserList] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    UserList();
  }, [currentPage]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setCurrentPage(1);
      UserList();
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery]);

  // useEffect(() => {
  //   if (!searchQuery) {
  //     setFilteredUsers(UserLists);
  //   } else {
  //     const lowerSearch = searchQuery.toLowerCase();
  //     const filtered = UserLists.filter(
  //       (user) =>
  //         user.full_name.toLowerCase().includes(lowerSearch) ||
  //         user.email.toLowerCase().includes(lowerSearch)
  //     );
  //     setUserList(filtered);
  //   }
  // }, [searchQuery, UserLists]);

  const UserList = async () => {
    try {
      setLoading(true);
      let result = await fetch(
        `${REACT_APP_API_URL}get-user?page=${currentPage}&limit=10&search=${searchQuery}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          },
        }
      );
      result = await result.json();
      console.log(">>>> Response:", result);

      if (Array.isArray(result.data.users)) {
        setUserList(result.data.users);
        setFilteredUsers(result.data.users);
        setTotalPages(result.data.totalPages);
        console.log("UserLists after setting:", result.data.users);
      } else {
        setUserList([]);
        setFilteredUsers([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleDelete = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        let response = await fetch(`${REACT_APP_API_URL}delete-user?id=${id}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          },
        });

        response = await response.json();

        if (response.success) {
          Swal.fire("Deleted!", "User has been deleted.", "success");

          const remainingUsers = UserLists.length - 1;

          if (remainingUsers === 0 && currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
          } else {
            UserList();
          }
        } else {
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const UpdateStatus = async (id, currentStatus) => {
    try {
      console.log(">>>>>>>><><><><><><><>", id, currentStatus);
      const newStatus = currentStatus === "blocked" ? "unblocked" : "blocked";

      const result = await Swal.fire({
        title: "Are you sure?",
        text: `Do you want to ${newStatus} this user?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: `Yes, ${newStatus} it!`,
      });

      if (result.isConfirmed) {
        let response = await fetch(`${REACT_APP_API_URL}updateuserstatus`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          },
          body: JSON.stringify({ id, status: newStatus }),
        });

        response = await response.json();
        console.log("response");

        if (response) {
          Swal.fire("Updated!", `User has been ${newStatus}.`, "success");
          setUserList((prev) =>
            prev.map((user) =>
              user.id === id ? { ...user, status: newStatus } : user
            )
          );
          setFilteredUsers((prev) =>
            prev.map((user) =>
              user.id === id ? { ...user, status: newStatus } : user
            )
          );
        } else {
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Layout>
      <div className="card">
        <div className="d-flex align-items-center justify-content-between px-5 py-3">
          <div className="nav-item d-flex align-items-center border rounded-2 ps-2">
            <BiSearch className="bx-md" />
            <input
              type="text"
              className="form-control border-0 shadow-none ps-1 ps-sm-2"
              placeholder="Search..."
              aria-label="Search..."
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
        </div>
        <div className="table-responsive text-nowrap">
          <table className="table">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Profile</th>
                <th>Name</th>
                <th>Gmail</th>
                <th>Action</th>
                <th>Option</th>
              </tr>
            </thead>
            <tbody className="table-border-bottom-0">
              {loading ? (
                [...Array(5)].map((_, index) => (
                  <tr key={index}>
                    <td>
                      <div
                        className="shimmer-loader"
                        style={{ width: "20px" }}
                      ></div>
                    </td>
                    <td>
                      <div
                        className="shimmer-loader"
                        style={{
                          width: "65px",
                          height: "65px",
                          borderRadius: "50%",
                        }}
                      ></div>
                    </td>
                    <td>
                      <div
                        className="shimmer-loader"
                        style={{ width: "120px" }}
                      ></div>
                    </td>
                    <td>
                      <div
                        className="shimmer-loader"
                        style={{ width: "150px" }}
                      ></div>
                    </td>
                    <td>
                      <div
                        className="shimmer-loader"
                        style={{ width: "40px", height: "20px" }}
                      ></div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <div
                          className="shimmer-loader"
                          style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                          }}
                        ></div>
                        <div
                          className="shimmer-loader"
                          style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                          }}
                        ></div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : UserLists.length > 0 ? (
                UserLists.map((item, index) => (
                  <tr key={index}>
                    <td style={{ paddingLeft: 32 }}>
                      {(currentPage - 1) * 10 + index + 1}
                    </td>
                    <td>
                      <img
                        src={
                          item.image
                            ? `http://66.29.152.162:4000/data/userImages/${item.image}`
                            : Image
                        }
                        style={{
                          width: "65px",
                          height: "65px",
                          objectFit: "cover",
                        }}
                        className="rounded-pill"
                        alt=""
                      />
                    </td>
                    <td>{item.full_name}</td>
                    <td>
                      <p className="para m-0">{item.email}</p>
                    </td>
                    <td>
                      <div className="form-check form-switch">
                        <Inputbox
                          type="checkbox"
                          className="form-check-input"
                          id={`switch-${item.id}`}
                          role="switch"
                          checked={item.status === "blocked"}
                          onChange={() => UpdateStatus(item.id, item.status)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`switch-${item.id}`}
                        ></label>
                      </div>
                    </td>

                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <Link
                          to={`/users/detail/${item.id}`}
                          className="btn btn-icon badge bg-label-success"
                        >
                          <BiShow className="icon-md bx" />
                        </Link>
                        <button
                          onClick={() => handleDelete(item.id)}
                          className="btn btn-icon delete-record badge bg-label-danger"
                        >
                          <BiTrash className="icon-md bx" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    {searchQuery.trim() !== ""
                      ? "No users match your search criteria."
                      : "No users found."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination - Only show when not searching */}
        {totalPages > 1 && searchQuery.trim() === "" && (
          <div className="d-flex justify-content-center py-3">
            <nav>
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link rounded-2 px-3"
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(1, prev - 1))
                    }
                  >
                    Previous
                  </button>
                </li>

                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                  (page) => (
                    <li
                      key={page}
                      className={`page-item ${
                        currentPage === page ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    </li>
                  )
                )}

                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link rounded-2 px-3"
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(totalPages, prev + 1))
                    }
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>

      <style>
        {`
        .shimmer-loader {
          width: 100%;
          height: 20px;
          background: linear-gradient(90deg, #f6f7f8 25%, #edeef1 50%, #f6f7f8 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite linear;
          border-radius: 4px;
        }

        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }

        .page-item.active .page-link {
          background-color: #264A2E;
          border-color: #264A2E;
        }

        .page-link {
          color: #264A2E;
        }
        `}
      </style>
    </Layout>
  );
};

export default Users;
